import React from 'react';
import PropTypes from 'prop-types';

import SettingsForm from './SettingsForm';
import RightPane from './RightPane';
import BottomPane from './BottomPane';

const GraphicalStatisticsComponent = ({
  isFirstParamNumerical,
  isFirstParamCategorical,
  isSecondParamNumerical,
  isSecondParamCategorical,

  firstParameterName,
  secondParameterName,

  firstParameterType,
  secondParameterType,

  numericalName,
  categoricalName,

  showBottomPane,
  showRightAndBottomPanes,
  firstParameterSelected,

  showHistogramFields,
  onFirstParameterNameChange,
  onSecondParameterNameChange,

  isFrequencyTable
}) => {
  return (
    <div className="page-main__indent">
      <div className="flex flex-grow">
        <div id="left-pfane" className="settings-width mb-15 mr-15">
          <SettingsForm
            numericalName={numericalName}
            firstParameterName={firstParameterName}
            firstParameterSelected={firstParameterSelected}
            firstParameterType={firstParameterType}
            secondParameterName={secondParameterName}
            secondParameterType={secondParameterType}
            showHistogramFields={showHistogramFields}
            onFirstParameterNameChange={onFirstParameterNameChange}
            onSecondParameterNameChange={onSecondParameterNameChange}
            isFrequencyTable={isFrequencyTable}
          />
        </div>

        <div id="right-pane" className="graph-width mb-15">
          <RightPane
            showGraphs={showRightAndBottomPanes}
            isFrequencyTable={isFrequencyTable}
            isFirstParamNumerical={isFirstParamNumerical}
            isFirstParamCategorical={isFirstParamCategorical}
            isSecondParamNumerical={isSecondParamNumerical}
            isSecondParamCategorical={isSecondParamCategorical}
            firstParameterName={firstParameterName}
            secondParameterName={secondParameterName}
            firstParameterType={firstParameterType}
            secondParameterType={secondParameterType}
          />
        </div>
      </div>

      {showBottomPane &&
        <div id="bottom-pane" className="mb-15">
          <BottomPane
            isFrequencyTable={isFrequencyTable}
            isFirstParamNumerical={isFirstParamNumerical}
            isFirstParamCategorical={isFirstParamCategorical}
            isSecondParamNumerical={isSecondParamNumerical}
            isSecondParamCategorical={isSecondParamCategorical}

            firstParameterName={firstParameterName}
            secondParameterName={secondParameterName}
            firstParameterType={firstParameterType}
            secondParameterType={secondParameterType}
            numericalName={numericalName}
            categoricalName={categoricalName}
          />
        </div>
      }
    </div>
  );
};

GraphicalStatisticsComponent.propTypes = {
  firstParameterName: PropTypes.string,
  secondParameterName: PropTypes.string,
  firstParameterType: PropTypes.string,
  secondParameterType: PropTypes.string,
  isFirstParamNumerical: PropTypes.bool.isRequired,
  isFirstParamCategorical: PropTypes.bool.isRequired,
  isSecondParamNumerical: PropTypes.bool.isRequired,
  isSecondParamCategorical: PropTypes.bool.isRequired,

  numericalName: PropTypes.string.isRequired,
  categoricalName: PropTypes.string.isRequired,
  firstParameterSelected: PropTypes.bool.isRequired,

  onFirstParameterNameChange: PropTypes.func.isRequired,
  onSecondParameterNameChange: PropTypes.func.isRequired,

  showBottomPane: PropTypes.bool.isRequired,
  showRightAndBottomPanes: PropTypes.bool.isRequired,

  isFrequencyTable: PropTypes.bool.isRequired,

  showHistogramFields: PropTypes.bool
};

GraphicalStatisticsComponent.defaultProps = {
  firstParameterName: null,
  secondParameterName: null,
  showHistogramFields: false
};

export default GraphicalStatisticsComponent;
